import { useState, useContext } from 'react';
import StoreContext from 'Shared/context/StoreContext';

export const usePermission = () => {
  const { permissions: userPermissions } = useContext(StoreContext);
  const [cache, setCache] = useState({});

  return (permissions = []) => {
    const key = permissions.join(',');

    if (key in cache) {
      return cache[key];
    } else {
      const isValid = permissions.every((perm) => userPermissions.includes(perm));
      setCache((prevCache) => ({
        ...prevCache,
        [key]: isValid,
      }));

      return isValid;
    }
  };
};

export const PERMISSIONS = {
  add_allocation: 'add_allocation',
  add_allocationlog: 'add_allocationlog',
  add_application: 'add_application',
  add_assignment: 'add_assignment',
  add_assignmentscheduleitem: 'add_assignmentscheduleitem',
  add_backup: 'add_backup',
  add_bank: 'add_bank',
  add_bankaccountbalance: 'add_bankaccountbalance',
  add_book: 'add_book',
  add_build: 'add_build',
  add_city: 'add_city',
  add_clientcontract: 'add_clientcontract',
  add_communicationhistory: 'add_communicationhistory',
  add_company: 'add_company',
  add_constance: 'add_constance',
  add_contact: 'add_contact',
  add_contenttype: 'add_contenttype',
  add_country: 'add_country',
  add_customerprofile: 'add_customerprofile',
  add_cvscreeningoption: 'add_cvscreeningoption',
  add_cvscreeningvalue: 'add_cvscreeningvalue',
  add_document: 'add_document',
  add_emailhistory: 'add_emailhistory',
  add_emailtemplate: 'add_emailtemplate',
  add_employeecontract: 'add_employeecontract',
  add_employeeprofile: 'add_employeeprofile',
  add_equipment: 'add_equipment',
  add_escalatelead: 'add_escalatelead',
  add_exchangerate: 'add_exchangerate',
  add_exchangetransaction: 'add_exchangetransaction',
  add_expensereason: 'add_expensereason',
  add_expenserequest: 'add_expenserequest',
  add_extraincome: 'add_extraincome',
  add_extraincomecategory: 'add_extraincomecategory',
  add_group: 'add_group',
  add_interview: 'add_interview',
  add_inventory: 'add_inventory',
  add_invoice: 'add_invoice',
  add_invoiceline: 'add_invoiceline',
  add_kvstore: 'add_kvstore',
  add_lead: 'add_lead',
  add_leadhistory: 'add_leadhistory',
  add_leadsource: 'add_leadsource',
  add_leaverequest: 'add_leaverequest',
  add_leaverequestcategory: 'add_leaverequestcategory',
  add_link: 'add_link',
  add_logentry: 'add_logentry',
  add_massemail: 'add_massemail',
  add_order: 'add_order',
  add_orderline: 'add_orderline',
  add_payment: 'add_payment',
  add_paymentterms: 'add_paymentterms',
  add_payslip: 'add_payslip',
  add_pdffile: 'add_pdffile',
  add_pdftemplate: 'add_pdftemplate',
  add_permission: 'add_permission',
  add_position: 'add_position',
  add_price: 'add_price',
  add_recurringservice: 'add_recurringservice',
  add_region: 'add_region',
  add_requirements: 'add_requirements',
  add_service: 'add_service',
  add_session: 'add_session',
  add_site: 'add_site',
  add_skill: 'add_skill',
  add_skillemployee: 'add_skillemployee',
  add_stage: 'add_stage',
  add_stagechangelead: 'add_stagechangelead',
  add_stocktakingrecord: 'add_stocktakingrecord',
  add_tag: 'add_tag',
  add_tagrule: 'add_tagrule',
  add_taskwitharguments: 'add_taskwitharguments',
  add_tokenauth: 'add_tokenauth',
  add_user: 'add_user',
  add_workstation: 'add_workstation',
  can_add_expenserequest: 'can_add_expenserequest',
  can_add_leaverequest: 'can_add_leaverequest',
  change_allocation: 'change_allocation',
  change_allocationlog: 'change_allocationlog',
  change_application: 'change_application',
  change_assignment: 'change_assignment',
  change_assignmentscheduleitem: 'change_assignmentscheduleitem',
  change_backup: 'change_backup',
  change_bank: 'change_bank',
  change_bankaccountbalance: 'change_bankaccountbalance',
  change_book: 'change_book',
  change_build: 'change_build',
  change_city: 'change_city',
  change_clientcontract: 'change_clientcontract',
  change_communicationhistory: 'change_communicationhistory',
  change_company: 'change_company',
  change_config: 'change_config',
  change_constance: 'change_constance',
  change_contact: 'change_contact',
  change_contenttype: 'change_contenttype',
  change_country: 'change_country',
  change_customerprofile: 'change_customerprofile',
  change_cvscreeningoption: 'change_cvscreeningoption',
  change_cvscreeningvalue: 'change_cvscreeningvalue',
  change_document: 'change_document',
  change_emailhistory: 'change_emailhistory',
  change_emailtemplate: 'change_emailtemplate',
  change_employeecontract: 'change_employeecontract',
  change_employeeprofile: 'change_employeeprofile',
  change_equipment: 'change_equipment',
  change_escalatelead: 'change_escalatelead',
  change_exchangerate: 'change_exchangerate',
  change_exchangetransaction: 'change_exchangetransaction',
  change_expensereason: 'change_expensereason',
  change_expenserequest: 'change_expenserequest',
  change_extraincome: 'change_extraincome',
  change_extraincomecategory: 'change_extraincomecategory',
  change_group: 'change_group',
  change_interview: 'change_interview',
  change_inventory: 'change_inventory',
  change_invoice: 'change_invoice',
  change_invoiceline: 'change_invoiceline',
  change_kvstore: 'change_kvstore',
  change_lead: 'change_lead',
  change_leadhistory: 'change_leadhistory',
  change_leadsource: 'change_leadsource',
  change_leaverequest: 'change_leaverequest',
  change_leaverequestcategory: 'change_leaverequestcategory',
  change_link: 'change_link',
  change_logentry: 'change_logentry',
  change_massemail: 'change_massemail',
  change_order: 'change_order',
  change_orderline: 'change_orderline',
  change_payment: 'change_payment',
  change_paymentterms: 'change_paymentterms',
  change_payslip: 'change_payslip',
  change_pdffile: 'change_pdffile',
  change_pdftemplate: 'change_pdftemplate',
  change_permission: 'change_permission',
  change_position: 'change_position',
  change_price: 'change_price',
  change_recurringservice: 'change_recurringservice',
  change_region: 'change_region',
  change_requirements: 'change_requirements',
  change_service: 'change_service',
  change_session: 'change_session',
  change_site: 'change_site',
  change_skill: 'change_skill',
  change_skillemployee: 'change_skillemployee',
  change_stage: 'change_stage',
  change_stagechangelead: 'change_stagechangelead',
  change_stocktakingrecord: 'change_stocktakingrecord',
  change_tag: 'change_tag',
  change_tagrule: 'change_tagrule',
  change_taskwitharguments: 'change_taskwitharguments',
  change_tokenauth: 'change_tokenauth',
  change_user: 'change_user',
  change_workstation: 'change_workstation',
  delete_allocation: 'delete_allocation',
  delete_allocationlog: 'delete_allocationlog',
  delete_application: 'delete_application',
  delete_assignment: 'delete_assignment',
  delete_assignmentscheduleitem: 'delete_assignmentscheduleitem',
  delete_backup: 'delete_backup',
  delete_bank: 'delete_bank',
  delete_bankaccountbalance: 'delete_bankaccountbalance',
  delete_book: 'delete_book',
  delete_build: 'delete_build',
  delete_city: 'delete_city',
  delete_clientcontract: 'delete_clientcontract',
  delete_communicationhistory: 'delete_communicationhistory',
  delete_company: 'delete_company',
  delete_constance: 'delete_constance',
  delete_contact: 'delete_contact',
  delete_contenttype: 'delete_contenttype',
  delete_country: 'delete_country',
  delete_customerprofile: 'delete_customerprofile',
  delete_cvscreeningoption: 'delete_cvscreeningoption',
  delete_cvscreeningvalue: 'delete_cvscreeningvalue',
  delete_document: 'delete_document',
  delete_emailhistory: 'delete_emailhistory',
  delete_emailtemplate: 'delete_emailtemplate',
  delete_employeecontract: 'delete_employeecontract',
  delete_employeeprofile: 'delete_employeeprofile',
  delete_equipment: 'delete_equipment',
  delete_escalatelead: 'delete_escalatelead',
  delete_exchangerate: 'delete_exchangerate',
  delete_exchangetransaction: 'delete_exchangetransaction',
  delete_expensereason: 'delete_expensereason',
  delete_expenserequest: 'delete_expenserequest',
  delete_extraincome: 'delete_extraincome',
  delete_extraincomecategory: 'delete_extraincomecategory',
  delete_group: 'delete_group',
  delete_interview: 'delete_interview',
  delete_inventory: 'delete_inventory',
  delete_invoice: 'delete_invoice',
  delete_invoiceline: 'delete_invoiceline',
  delete_kvstore: 'delete_kvstore',
  delete_lead: 'delete_lead',
  delete_leadhistory: 'delete_leadhistory',
  delete_leadsource: 'delete_leadsource',
  delete_leaverequest: 'delete_leaverequest',
  delete_leaverequestcategory: 'delete_leaverequestcategory',
  delete_link: 'delete_link',
  delete_logentry: 'delete_logentry',
  delete_massemail: 'delete_massemail',
  delete_order: 'delete_order',
  delete_orderline: 'delete_orderline',
  delete_payment: 'delete_payment',
  delete_paymentterms: 'delete_paymentterms',
  delete_payslip: 'delete_payslip',
  delete_pdffile: 'delete_pdffile',
  delete_pdftemplate: 'delete_pdftemplate',
  delete_permission: 'delete_permission',
  delete_position: 'delete_position',
  delete_price: 'delete_price',
  delete_recurringservice: 'delete_recurringservice',
  delete_region: 'delete_region',
  delete_requirements: 'delete_requirements',
  delete_service: 'delete_service',
  delete_session: 'delete_session',
  delete_site: 'delete_site',
  delete_skill: 'delete_skill',
  delete_skillemployee: 'delete_skillemployee',
  delete_stage: 'delete_stage',
  delete_stagechangelead: 'delete_stagechangelead',
  delete_stocktakingrecord: 'delete_stocktakingrecord',
  delete_tag: 'delete_tag',
  delete_tagrule: 'delete_tagrule',
  delete_taskwitharguments: 'delete_taskwitharguments',
  delete_tokenauth: 'delete_tokenauth',
  delete_user: 'delete_user',
  delete_workstation: 'delete_workstation',
  view_allocation: 'view_allocation',
  view_allocationlog: 'view_allocationlog',
  view_application: 'view_application',
  view_assignment: 'view_assignment',
  view_assignmentscheduleitem: 'view_assignmentscheduleitem',
  view_backup: 'view_backup',
  view_bank: 'view_bank',
  view_bankaccountbalance: 'view_bankaccountbalance',
  view_book: 'view_book',
  view_build: 'view_build',
  view_city: 'view_city',
  view_clientcontract: 'view_clientcontract',
  view_communicationhistory: 'view_communicationhistory',
  view_company: 'view_company',
  view_constance: 'view_constance',
  view_contact: 'view_contact',
  view_contenttype: 'view_contenttype',
  view_country: 'view_country',
  view_customerprofile: 'view_customerprofile',
  view_cvscreeningoption: 'view_cvscreeningoption',
  view_cvscreeningvalue: 'view_cvscreeningvalue',
  view_document: 'view_document',
  view_emailhistory: 'view_emailhistory',
  view_emailtemplate: 'view_emailtemplate',
  view_employeecontract: 'view_employeecontract',
  view_employeeprofile: 'view_employeeprofile',
  view_equipment: 'view_equipment',
  view_escalatelead: 'view_escalatelead',
  view_exchangerate: 'view_exchangerate',
  view_exchangetransaction: 'view_exchangetransaction',
  view_expensereason: 'view_expensereason',
  view_expenserequest: 'view_expenserequest',
  view_extraincome: 'view_extraincome',
  view_extraincomecategory: 'view_extraincomecategory',
  view_group: 'view_group',
  view_interview: 'view_interview',
  view_inventory: 'view_inventory',
  view_invoice: 'view_invoice',
  view_invoiceline: 'view_invoiceline',
  view_kvstore: 'view_kvstore',
  view_lead: 'view_lead',
  view_leadhistory: 'view_leadhistory',
  view_leadsource: 'view_leadsource',
  view_leaverequest: 'view_leaverequest',
  view_leaverequestcategory: 'view_leaverequestcategory',
  view_link: 'view_link',
  view_logentry: 'view_logentry',
  view_massemail: 'view_massemail',
  view_order: 'view_order',
  view_orderline: 'view_orderline',
  view_payment: 'view_payment',
  view_paymentterms: 'view_paymentterms',
  view_payslip: 'view_payslip',
  view_pdffile: 'view_pdffile',
  view_pdftemplate: 'view_pdftemplate',
  view_permission: 'view_permission',
  view_position: 'view_position',
  view_price: 'view_price',
  view_recurringservice: 'view_recurringservice',
  view_region: 'view_region',
  view_requirements: 'view_requirements',
  view_service: 'view_service',
  view_session: 'view_session',
  view_site: 'view_site',
  view_skill: 'view_skill',
  view_skillemployee: 'view_skillemployee',
  view_stage: 'view_stage',
  view_stagechangelead: 'view_stagechangelead',
  view_stocktakingrecord: 'view_stocktakingrecord',
  view_tag: 'view_tag',
  view_tagrule: 'view_tagrule',
  view_taskwitharguments: 'view_taskwitharguments',
  view_tokenauth: 'view_tokenauth',
  view_user: 'view_user',
  view_workstation: 'view_workstation',
  add_project: 'add_project',
  view_project: 'view_project',
  delete_project: 'delete_project',
  change_project: 'change_project',
};
